export const TAB_KEYS = {
  MERGE: "Merge",
  CR: "CR",
  CP: "CP",
  MANUAL_RECONCILED: "ManualReconciled",
  AUTO_RECONCILED: "AutoReconciled",
  OUTSTANDING: "Outstanding Transactions Report",
};

export const TAB_ITEMS = [
  { key: TAB_KEYS.MERGE, label: "Bank Unrec Trans" },
  { key: TAB_KEYS.CR, label: "Book Credit Outstanding" },
  { key: TAB_KEYS.CP, label: "Book Debit Outstanding" },
  { key: TAB_KEYS.MANUAL_RECONCILED, label: "Manual Reconciled" },
  { key: TAB_KEYS.AUTO_RECONCILED, label: "Auto Reconciled" },
  { key: TAB_KEYS.OUTSTANDING, label: "Outstanding Transactions Report" },
];